import Immutable from 'immutable';

export function makeIdToContactMap(contactsList) {
  return Immutable.fromJS(contactsList)
    .toMap()
    .mapKeys((k, v) => v.get('id'));
}



// WEBPACK FOOTER //
// ./app/utils/contacts.jsx